import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export default class StoreCustomData {
  constructor() {
    _defineProperty(this, "paymentWalletsEnabled", {
      fieldName: 'wallet_payment',
      content: false
    });
    _defineProperty(this, "googleVerificationString", {
      fieldName: 'google-verification-string',
      content: null
    });
    _defineProperty(this, "facebookVerificationString", {
      fieldName: 'facebook-verification-string',
      content: null
    });
    _defineProperty(this, "googleSiteVerification", {
      fieldName: 'google-site-verification',
      content: null
    });
    _defineProperty(this, "facebookDomainVerification", {
      fieldName: 'facebook-domain-verification',
      content: null
    });
  }
  isPaymentWalletsEnabled() {
    return this.paymentWalletsEnabled.content;
  }
}